import { render, staticRenderFns } from "./mailbox-settings-checklist-templates.vue?vue&type=template&id=488221c0&"
import script from "./mailbox-settings-checklist-templates.vue?vue&type=script&lang=ts&"
export * from "./mailbox-settings-checklist-templates.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-settings-checklist-templates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports